import type { IBanner } from '@/types/banner';
import { request } from './client';

export function fetchOrderBanners(
  orderId: string | number,
  params?: Record<string, string | number>
): Promise<{ data: IBanner[] }> {
  return request('GET', `/v1/account/order/${orderId}/banners`, params);
}
export function fetchBannerById(bannerId: string | number, params?: Record<string, string | number>): Promise<IBanner> {
  return request('GET', `/v1/account/banner/${bannerId}.json`, params);
}
export function updateBannerById(
  bannerId: string | number,
  bannerData: IBanner,
  params?: Record<string, string | number>
): Promise<IBanner> {
  return request('PUT', `/v1/account/banner/${bannerId}.json`, params, bannerData);
}
